import { gql, useLazyQuery, useQuery } from "@apollo/client";
import { AllUsers } from "./schema/AllUsers";
import { AvailableRoles } from "./schema/AvailableRoles";

export const allUsersList = gql`
  query AllUsers {
    tenant {
      access {
        users {
          roles
          permissions
          name
          lastName
          firstName
        }
      }
    }
  }
`;

export const availableRolesList = gql`
  query AvailableRoles {
    tenant {
      access {
        availableRoles
      }
    }
  }
`;

export const useQueryGetAllUsers = () => useLazyQuery<AllUsers>(allUsersList);

export const useQueryGetAvailableRoles = () =>
  useQuery<AvailableRoles>(availableRolesList);
